import { computed, MaybeRefOrGetter, ref, toRef, watch } from 'vue';
import { HasCommentSummary } from './types';
import { PtwCommentDto } from '@/api/generator';
import { t } from 'i18next';

export function useAmountComments(entity: MaybeRefOrGetter<HasCommentSummary & object>) {
  const entityRef = toRef(entity);

  const amountComments = ref<number | undefined>(undefined);

  watch(
    () => entityRef.value.comments,
    () => {
      amountComments.value = entityRef.value.commentCount ?? entityRef.value.comments?.length ?? 0;
    },
    {
      immediate: true,
    },
  );

  const commentsChanged = (comments: PtwCommentDto[] | undefined) => {
    amountComments.value = comments?.length ?? 0;
  };

  const commentsTabTitle = computed(
    () => `${t('Comments')}${amountComments.value ? ' (' + amountComments.value + ')' : ''}`,
  );

  return {
    amountComments,
    commentsChanged,
    commentsTabTitle,
  };
}
